var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25 35.4167V22.9167",
    stroke: "black",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25 14.5833C26.1506 14.5833 27.0833 15.5161 27.0833 16.6667C27.0833 17.8173 26.1506 18.75 25 18.75C23.8494 18.75 22.9167 17.8173 22.9167 16.6667C22.9167 15.5161 23.8494 14.5833 25 14.5833Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5833 6.9538C17.6477 5.18119 21.2054 4.16667 25 4.16667C36.5058 4.16667 45.8333 13.4941 45.8333 25C45.8333 36.5058 36.5058 45.8333 25 45.8333C13.4941 45.8333 4.16667 36.5058 4.16667 25C4.16667 21.2054 5.18119 17.6477 6.9538 14.5833",
    stroke: "black",
    strokeWidth: 3,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.b8264b10465fedd93a6c391cbaedef38.svg";
export { ForwardRef as ReactComponent };